import React from 'react';

import type {LicenseType} from 'nutshell-graphql-types';
import type {GetLicenseOverview_licenseOverview_instanceLicenses as LicenseInfo} from 'nutshell-graphql-types';

import {SwitchContainer} from './switch-container';
import {SwitchName} from './switch-name';
import {SwitchText} from './switch-text';

type Props = {
    licenseType: LicenseType;
    licenseInfo: LicenseInfo;
    isOn: boolean;
    purchaseLink?: string | null | undefined;
    infoLink?: string | null | undefined;
    maxSeatsReached: boolean;
    isDisabled: boolean;
    handleSwitchToggle: (licenseType: LicenseType) => void;
};

export function LicenseSwitchHorizontal(props: Props) {
    const {
        licenseType,
        licenseInfo,
        isOn,
        purchaseLink,
        infoLink,
        maxSeatsReached,
        isDisabled,
        handleSwitchToggle,
    } = props;

    return (
        <div className='my-8 flex flex-dir-row justify-sb'>
            <div>
                <SwitchName displayName={licenseInfo.displayName} infoLink={infoLink} />
                <SwitchText
                    displayName={licenseInfo.displayName}
                    isPurchased={licenseInfo.isPurchased}
                    isUnlimited={licenseInfo.isUnlimited}
                    numUsed={licenseInfo.numUsed}
                    numBought={licenseInfo.numBought}
                    purchaseLink={purchaseLink}
                    maxSeatsReached={maxSeatsReached}
                />
            </div>
            <SwitchContainer
                licenseType={licenseType}
                isOn={isOn}
                handleSwitchToggle={handleSwitchToggle}
                isDisabled={isDisabled}
            />
        </div>
    );
}
